<template>
  <div class="approve-content">
    <div class="approve_nav">
      <ul class="nav_list">
        <li
          v-for="item in btnGroup"
          :key="item.type"
          :class="{ active: type === item.type }"
          @click="handle(item.type)"
        >
          {{ item.text }}
          <div v-if="item.type === 'upcoming'&&count!==0" class="badge">{{count}}</div>
        </li>
        <div class="item" :style="{ transform: 'translateX('+ distance+'px)'}"></div>
      </ul>
    </div>
    <keep-alive include="done">
      <component :is="currentView" @setCount="setCount"></component>
    </keep-alive>
  </div>
</template>

<script>
import upcoming from './upcoming';
import done from './done';
export default {
  components: {
    upcoming,
    done,
  },
  data() {
    return {
      btnGroup: [
        {
          type: 'upcoming',
          text: '待审批',
        },
        {
          type: 'done',
          text: '已审批',
        },
      ],
      type: 'upcoming',
      distance: '43.5',
      count: 0
    };
  },
  methods: {
    handle(str) {
      this.type = str;
      if(this.type === 'upcoming'){
        this.distance = 43.5;
      }else{
        this.distance = 118.5;
      }
    },
    setCount(count){
      this.count = count
    }
  },
  computed: {
    currentView() {
      return this.type;
    },
  },
};
</script>

<style lang="scss">
.approve-content {
  min-width: 729px;
  height: 100vh;
  background-color: #fff;
  .approve_nav {
    position: absolute;
    width: 259px;
    left: 20px;
    top: 0;
    background-color: #fff;
    z-index: 100;
  }
  .nav_list {
    box-sizing: border-box;
    padding: 32px 20px 4px;
    border-bottom: 1px solid $border-color;
    display: flex;
    position: relative;
    li {
      cursor: pointer;
      width: 75px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(32, 32, 32, 1);
      position: relative;
      .badge{
        padding: 0 4px;
        position: absolute;
        top: 0;
        left: 57px;
        background:rgba(255,112,112,1);
        box-shadow:0px 2px 4px 0px rgba(255,112,112,0.3);
        border-radius: 25px;
        text-align: center;
        line-height: 18px;
        font-size:12px;
        color: #fff;
      }
    }
    .item{
      width:28px;
      height:3px;
      background:linear-gradient(135deg,rgba(74,216,200,1) 0%,rgba(33,154,242,1) 100%);
      box-shadow:0px 3px 4px 0px rgba(11,183,190,0.2);
      border-radius:2px;
      position: absolute;
      left: 0;
      bottom: 4px;
      transition-duration: 0.3s;
    }
  }
  .layout-pc {
    height: 100vh;
    display: flex;
    ::-webkit-scrollbar {
      width: 5px; /*竖向滚动条的宽度*/
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      /*滚动条里面的小方块*/
      background-color: transparent;
      border-radius: 5px;
    }
    .list {
      min-width: 279px;
      width: 279px;
      padding-top: 96px;
      border-right: 0.5px solid $border-color;
      height: calc(100vh - 100px);
      overflow-y: auto;

      &:hover::-webkit-scrollbar-thumb {
        background-color: #0BB7BE;
      }
    }
    .layout-content {
      flex: 1;
      background: #f8fafa;
      display: flex;
      flex-direction: column;
      .header {
        display: flex;
        box-sizing: border-box;
        height: 76px;
        padding: 42px 19px 10px;
        background-color: #fff;
        justify-content: space-between;
        user-select: none;
        p {
          height: 24px;
          line-height: 24px;
          font-size: 17px;
          font-weight: 500;
          color: rgba(32, 32, 32, 1);
        }
        .van-icon {
          font-size: 20px;
          cursor: pointer;
        }
        span{
          min-width: 20px;
        }
      }
      .content{
        flex: 1;
        iframe{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .loading{
    padding-top: 10px;
    text-align: center;
  }
}
</style>
